// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login__Logo {
  height: 2rem;
  width: 15rem;
  background: url('_-_-_-_-_-_-apps-app-src-assets-img-Logo_white.png');
  background-size: contain;
  background-repeat: no-repeat;
}
.Login__Button {
  flex-basis: 100%;
  justify-content: flex-start;
}
.Login__ContentWrapper {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Login__ContentWrapper:before {
  content: "";
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.6;
  background: url('login-bkg.jpg');
  background-size: cover;
  background-position: center;
}
.Login__Card {
  max-width: 50rem;
  width: 100%;
}
.Login__SocialButtons {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.Login__Message {
  width: 100%;
  text-align: center;
  margin: 1rem 0 0.5rem 0;
}
.Login__FormWrapper {
  max-width: 22rem;
  display: inline-block;
}
.Login__Copyright {
  font-size: 0.75rem;
  color: white;
}

i,
ion-icon {
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./libs/features/views/login/src/lib/login.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,YAAA;EACA,qEAAA;EACA,wBAAA;EACA,4BAAA;AAAJ;AAGE;EACE,gBAAA;EACA,2BAAA;AADJ;AAIE;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;AAII;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,sBAAA;EACA,2BAAA;AAFN;AAME;EACE,gBAAA;EACA,WAAA;AAJJ;AAOE;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AALJ;AAQE;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;AANJ;AASE;EACE,gBAAA;EACA,qBAAA;AAPJ;AAUE;EACE,kBAAA;EACA,YAAA;AARJ;;AAYA;;EAEE,kBAAA;AATF","sourcesContent":[".Login {\n  &__Logo {\n    height: 2rem;\n    width: 15rem;\n    background: url('./../../../../../../apps/app/src/assets/img/Logo_white.png');\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n\n  &__Button {\n    flex-basis: 100%;\n    justify-content: flex-start;\n  }\n\n  &__ContentWrapper {\n    width: 100%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    &:before {\n      content: '';\n      position: absolute;\n      z-index: 0;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      opacity: 0.6;\n      background: url(./../../../../../../apps/app/src/assets/login-bkg.jpg);\n      background-size: cover;\n      background-position: center;\n    }\n  }\n\n  &__Card {\n    max-width: 50rem;\n    width: 100%;\n  }\n\n  &__SocialButtons {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  &__Message {\n    width: 100%;\n    text-align: center;\n    margin: 1rem 0 0.5rem 0;\n  }\n\n  &__FormWrapper {\n    max-width: 22rem;\n    display: inline-block;\n  }\n\n  &__Copyright {\n    font-size: 0.75rem;\n    color: white;\n  }\n}\n\ni,\nion-icon {\n  margin-right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
